import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  NO_FLAG,
} from '@common/constants/sharedConstants';

import {
  yesNoFlagPropTypes,
} from '../../shared/propTypes';

import {
  sharedActions,
} from './store/actions';

class TaxRatesAdminColumnRenderer extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({
      companyCode: PropTypes.string,
      isDeletable: yesNoFlagPropTypes,
    }),
    showTaxRatesModalForEdit: PropTypes.func.isRequired,
    showTaxRatesModalForDelete: PropTypes.func.isRequired,
    rowIndex: PropTypes.number.isRequired,
  };

  showTaxRatesModalForEdit = () => {
    const { data, showTaxRatesModalForEdit } = this.props;
    showTaxRatesModalForEdit(data);
  };

  showTaxRatesModalForDelete = () => {
    const { data, showTaxRatesModalForDelete, rowIndex } = this.props;
    showTaxRatesModalForDelete({
      entity: data,
      rowIndex,
    });
  };

  render() {
    const { isDeletable } = this.props.data;
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Tax Rate"
          onClick={this.showTaxRatesModalForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Tax Rate"
          onClick={this.showTaxRatesModalForDelete}
          disabled={isDeletable === NO_FLAG}
        >
          <TrashIcon
            size={16}
            className="cell-icon disabled-visible"
            data-tip={isDeletable === NO_FLAG ? 'Country Tax Type is assigned to an Obligation' : ''}
          />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showTaxRatesModalForEdit: sharedActions.showModalForAddEdit,
    showTaxRatesModalForDelete: sharedActions.showModalForRemove,
  }
)(TaxRatesAdminColumnRenderer);
